import { createReducer, on } from '@ngrx/store';
import { DeclinedMessageActions } from '../actions/declined-message.actions';
import { DeclinedState } from 'src/app/models/state/declined-state.model';
import { get, save } from 'src/app/data/utils/localstorage.util';

const DECLINED_MESSAGE_KEY = 'DeclinedState';

export const initialState: DeclinedState = {
	declinedMessage:
		'Te sugerimos atender cualquier situación que pudiera estar afectando tu historial crediticio y, si sigues interesado en nuestro crédito, realizar tu solicitud nuevamente en 1 mes',
	declinedCode: 'F301-001',
};

const getInitialState = (initialState): DeclinedState => {
	const stateFromLocalStorage = get<DeclinedState>(DECLINED_MESSAGE_KEY);
	if (stateFromLocalStorage !== null) {
		return stateFromLocalStorage;
	}
	return initialState;
};

export const declinedMessageReducer = createReducer(
	getInitialState(initialState),
	on(
		DeclinedMessageActions.addDeclinedMessage,
		(state, { message }): DeclinedState => {
			const newState: DeclinedState = {
				...state,
				declinedMessage: message,
			};
			saveStateToLocalStorage(newState);
			return newState;
		}
	),
	on(
		DeclinedMessageActions.addDeclinedCodeAndMessage,
		(state, { code, message }): DeclinedState => {
			const newState: DeclinedState = {
				declinedMessage: message ?? state.declinedMessage,
				declinedCode: code ?? state.declinedCode,
			};

			saveStateToLocalStorage(newState);
			return newState;
		}
	),
	on(
		DeclinedMessageActions.resetDeclinedMessage,
		(): DeclinedState => initialState
	)
);

function saveStateToLocalStorage(state: DeclinedState) {
	save<DeclinedState>(DECLINED_MESSAGE_KEY, state);
}
